import { inject, bindable, bindingMode, Container } from 'aurelia-framework'; // eslint-disable-line no-unused-vars
import moment from 'moment';
import 'daterangepicker';

@inject(Element)
export class DateRangePicker {
    @bindable({ defaultBindingMode: bindingMode.twoWay, changeHandler: 'startDateChanged' }) startDate;
    @bindable({ defaultBindingMode: bindingMode.twoWay, changeHandler: 'endDateChanged' }) endDate;
    @bindable({ defaultBindingMode: bindingMode.twoWay, changeHandler: 'ConfigChanged' }) minDate;
    @bindable({ defaultBindingMode: bindingMode.twoWay, changeHandler: 'ConfigChanged' }) maxDate;
    @bindable({ defaultBindingMode: bindingMode.twoWay, changeHandler: 'ConfigChanged' }) format = "DD/MM/YYYY";
    options;
    @bindable({ defaultBindingMode: bindingMode.twoWay }) disabled: boolean = false;
    get DisplayDate() {
        return (this.startDate == null ? "" : this.startDate) + " - " + (this.endDate == null ? "" : this.endDate);
    }

    element: any;
    owningView: any;

    created(owningView) {
        this.owningView = owningView;
    }

    attached() {
        var self = this;
        this.CreateConfig();

        if (self.startDate != null) {
            this.options = $.extend(this.options, {
                startDate: moment(self.startDate, self.options.locale.format)
            });
        }

        if (self.endDate != null) {
            this.options = $.extend(this.options, {
                endDate: moment(self.endDate, self.options.locale.format)
            });

        }

        $(this.element).daterangepicker(this.options);

        $(this.element).on('apply.daterangepicker', function (ev, picker) {
            self.apply(picker.startDate, picker.endDate);
        });

        $(this.element).on('cancel.daterangepicker', function (ev, picker) {
            self.apply(null, null);
        });
    }

    apply(startDate, endDate) {
        this.startDate = startDate == null ? null : startDate.format(this.options.locale.format);
        this.endDate = endDate == null ? null : endDate.format(this.options.locale.format);
    }

    startDateChanged(newValue) {
        if (this.owningView.isAttached && newValue != null) {
            $(this.element).data('daterangepicker').setStartDate(newValue);
        }
    }

    endDateChanged(newValue) {
        if (this.owningView.isAttached && newValue != null) {
            $(this.element).data('daterangepicker').setEndDate(newValue);
        }
    }

    ConfigChanged(newValue) {
        var self = this;
        this.CreateConfig();

        this.startDate = null;
        this.endDate = null;
        $(this.element).daterangepicker(this.options);

        $(this.element).on('apply.daterangepicker', function (ev, picker) {
            self.apply(picker.startDate, picker.endDate);
        });

        $(this.element).on('cancel.daterangepicker', function (ev, picker) {
            self.apply(null, null);
        });
    }

    CreateConfig() {
        var self = this;
        this.options = null;
        this.options = $.extend(true, {
            locale: {
                format: self.format,
                cancelLabel: 'Clear'
            }
        }, this.options);

        if (self.minDate != null) {
            this.options = $.extend(this.options, {
                minDate: moment(self.minDate, self.options.locale.format)
            });
        }

        if (self.maxDate != null) {
            this.options = $.extend(this.options, {
                maxDate: moment(self.maxDate, self.options.locale.format)
            });

        }
        this.options = $.extend(this.options, {
            autoUpdateInput: false
        });

        this.options = $.extend(this.options, {
            autoUpdateInput: false
        });

    }
}